<template>
  <v-container :fluid="true" class="bg-light-beige ma-0 pa-0">
    <div class="page__title">
      Восстановление пароля
    </div>
    <div v-if="send_success">
      <div class="page__subtitle px-8 px-sm-10 px-lg-16 mb-10">
        На указанный вами почтовый адрес отправлено письмо.<br/> Для завершения процесса восстановления пароля перейдите по содержащейся в нем ссылке.
      </div>
      <div class="btn__next" @click="$router.push({name: names.MAIN})">
        <span class="btn__next_text">
          На главную
        </span>
      </div>
    </div>
    <div v-else>
      <div class="page__subtitle">
        Введите почту использованную при регистрации
      </div>
      <div class="text_field__container">
        <div class="text__field" v-if="error">
          <v-alert
              class="error_alert"
              :value="true"
              outline
              :icon="false"
              color="#8f0808"
              variant="outlined"
          >
            {{ error.error }}
          </v-alert>
        </div>
        <v-form
            v-model="valid"
            class="text_field__container"
        >
          <v-text-field
              class="text__field"
              color="#3254B9"
              base-color="#313743"
              variant="outlined"
              v-model="email"
              :loading="loading"
              name="login"
              :rules="[rules.email]"
              :error="hasError('email')"
              :error-messages="getError('email')"
          >
            <template v-slot:label>
              <div class="label__text">
                Электронная почта
              </div>
            </template>
          </v-text-field>
        </v-form>
        <div class="btn__next back" @click="$router.push({name: names.MAIN})">
          <span class="btn__next_text">
            Назад
          </span>
        </div>
        <v-btn
            class="btn__next"
            elevation="0"
            :disabled="!valid"
            :loading="loading"
            @click="sendForgetPass"
        >
          <span class="btn__next_text">
            Отправить
          </span>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import { mapActions, mapGetters } from "vuex"

export default defineComponent({
  name: "Recovery",
  mixins: [FormErrorsMixin],
  data () {
    return {
      loading: false,
      email: null,
      error: null,
      send_success: false,
      valid: false,
      rules: {
        email: value => {
          if (value !== null && value !== '') {
            const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,9})+$/
            return pattern.test(value) || 'Некорректный ввод'
          } else {
            return 'Введите адрес Вашей электронной почты'
          }
        },
      }
    }
  },
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    })
  },
  methods: {
    ...mapActions({
      forgetPass: 'personal_account/users/forgetPass',
    }),
    endRedirect () {
      this.$router.push({ name: pa_names.MAIN })
    },
    sendForgetPass: function () {
      this.loading = true
      this.error = null
      this.forgetPass(
        {
          data: { email: this.email },
          finalizer: () => {
            this.loading = false
            this.error = null
            this.send_success = true
          },
          catcher: (error) => {
            this.loading = false
            if (error.error === 'Ваш аккаунт еще не подтвержден. Пожалуйста, проверьте свою почту и подтвердите регистрацию') {
              this.$router.push({ name: names.EMAIL_RESEND.PAGE, query: { email: this.email, type: 'recovery' } })
            } else {
              this.error = error
            }
          }
        }
      )
    },
  },
  created () {
    if (this.isAuthenticated) { this.endRedirect() }
  },
})
</script>

<style scoped lang="scss">
.page__title {
  margin-top: 30px;
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 800;
  font-size: 75px;
  line-height: 84px;
  text-align: center;

  color: #3254B9;
}

.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.text_field__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 800px;
}

.text__field {
  margin: 0 auto 20px;
  width: 100%;
}

.v-field__field:hover {
  .label__text {
    color: black;
  }
}

.label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: center;

  color: #313743;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 220px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &.back {
    margin-right: 50px;
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }

    &:hover {
      background-color: #3254B9;

      .btn__next_text {
        color: #FFFFFF;
      }
    }
  }

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

@media screen and (max-width: 1920px) {
  .page__title {
    font-size: 65px;
    line-height: 74px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }

  .text__field {
    margin-bottom: 10px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1279px) {
  .page__title {
    font-size: 50px;
    line-height: 57px;
    padding: 0 40px;
  }

  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }

  .text_field__container {
    width: 600px;
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 30px;
    line-height: 37px;
    padding: 0 20px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .text_field__container {
    width: 400px;
  }

  .label__text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn__next {
    margin: 0 10px 20px;
    height: 55px;

    &.back {
      margin-right: 10px;
    }
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: normal;
  color: #8f0808;
  margin-bottom: 20px;
}

@media screen and (max-width: 600px) {
  .text_field__container {
    width: 270px;
  }

  .text__field {
    margin-bottom: 8px;
  }
}
</style>
